module.exports = __webpack_public_path__ + "img/open_local.a2806ace.svg";